import http from '../../services/http-common';

class AccessoryInfoService {
    
    getAccessoryInfoForList() {
    return http.get(`/AccessoryInfo/sp/list`);
    }
    insert(data) {
        return http.post(`/AccessoryInfo/db/add`,data);
    }
    update(data) {
        return http.put(`/AccessoryInfo/db/update`,data);
    }
}

export default new AccessoryInfoService();